import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_3 = {
  key: 1,
  class: "fas fa-save"
}
const _hoisted_4 = { class: "space-y-6" }
const _hoisted_5 = { class: "space-y-4" }
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4 items-center" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "space-y-4" }
const _hoisted_9 = { class: "border-b border-gray-200" }
const _hoisted_10 = { class: "-mb-px flex space-x-8" }
const _hoisted_11 = { class: "ml-2 bg-purple-100 text-purple-600 py-0.5 px-2 rounded-full text-xs" }
const _hoisted_12 = { class: "ml-2 bg-red-100 text-red-600 py-0.5 px-2 rounded-full text-xs" }
const _hoisted_13 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_14 = { class: "overflow-x-auto" }
const _hoisted_15 = { class: "min-w-full bg-white border border-gray-200 rounded-lg" }
const _hoisted_16 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "px-4 py-3 whitespace-nowrap text-sm text-black" }
const _hoisted_19 = { class: "px-4 py-3 whitespace-nowrap text-sm text-black" }
const _hoisted_20 = { class: "px-4 py-3 whitespace-nowrap text-sm text-black" }
const _hoisted_21 = { class: "px-4 py-3 whitespace-nowrap text-sm font-medium space-x-2" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_24 = { class: "overflow-x-auto" }
const _hoisted_25 = { class: "min-w-full bg-white border border-gray-200 rounded-lg" }
const _hoisted_26 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "px-4 py-3 whitespace-nowrap text-sm text-black" }
const _hoisted_29 = { class: "px-4 py-3 whitespace-nowrap text-sm text-black" }
const _hoisted_30 = { class: "px-4 py-3 whitespace-nowrap text-sm text-black" }

import { DataCard, BaseInput, ActionButton } from '@/components'
import { reactive, ref, computed } from 'vue'
import type { GeneralInformationFormData } from '@/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeavesSection',
  props: {
    formData: {},
    saving: { type: Boolean },
    disableSave: { type: Boolean }
  },
  emits: ["update:formData", "save", "add-leave"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const newLeave = reactive<{
  startDate: string
  endDate: string
}>({
  startDate: '',
  endDate: ''
})

// État des onglets
const activeTab = ref<'active' | 'deleted'>('active')

// Computed properties pour séparer les congés
const activeLeaves = computed(() => 
  props.formData.leaves.filter(leave => !leave.deleted)
)

const deletedLeaves = computed(() => 
  props.formData.leaves.filter(leave => leave.deleted)
)

const addLeave = () => {
  if (newLeave.startDate && newLeave.endDate) {
    // Validations
    const startDate = new Date(newLeave.startDate)
    const endDate = new Date(newLeave.endDate)

    // 1) Le début de congé doit être au minimum le lendemain de la date du jour
    const today = new Date()
    const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1)
    if (startDate < tomorrow) {
      alert('Le début de congé doit commencer à partir de demain')
      return
    }

    // 2) La fin de congé doit être strictement après le début de congé
    if (endDate <= startDate) {
      alert('La fin de congé doit être postérieure au début de congé')
      return
    }
    
    const updatedFormData = {
      ...props.formData,
      leaves: [
        ...props.formData.leaves,
        { startDate: newLeave.startDate, endDate: newLeave.endDate }
      ]
    }
    // On ne met PAS à jour localement tout de suite (pas de mise à jour
    // optimiste) : on laisse la sauvegarde se faire, puis loadVendeurData()
    // rafraîchira la liste. Ainsi la nouvelle ligne et la notification
    // apparaissent en même temps (plus d'effet "la ligne apparaît puis le
    // popup arrive après").
    emit('add-leave', updatedFormData)
    
    // Réinitialiser les champs
    newLeave.startDate = ''
    newLeave.endDate = ''
  }
}

const deleteLeave = (index: number) => {
  // Marquer comme supprimé au lieu de retirer du tableau
  // La suppression en DB se fera au moment de la sauvegarde générale avec supprimer = 1
  const updatedFormData = { ...props.formData }
  updatedFormData.leaves[index].deleted = true
  emit('update:formData', updatedFormData)
}

const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  return date.toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
}

// Helpers pour contraindre les dates des inputs de type date
const toInputDate = (date: Date) => {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

// Début de congé: à partir du lendemain de la date actuelle
const minStartDate = computed(() => {
  const now = new Date()
  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
  return toInputDate(tomorrow)
})

// Fin de congé: au moins le lendemain du début de congé sélectionné
const minEndDate = computed(() => {
  if (!newLeave.startDate) return ''
  const s = new Date(newLeave.startDate)
  const next = new Date(s.getFullYear(), s.getMonth(), s.getDate() + 1)
  return toInputDate(next)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataCard), {
    title: "Gestion des congés",
    icon: "fas fa-calendar-alt",
    "icon-color": "text-purple-600",
    "icon-bg-color": "bg-purple-100",
    class: "w-full"
  }, {
    "header-actions": _withCtx(() => [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('save'))),
        disabled: _ctx.saving || _ctx.disableSave,
        class: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
      }, [
        (_ctx.saving)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2))
          : (_openBlock(), _createElementBlock("i", _hoisted_3)),
        _createElementVNode("span", null, _toDisplayString(_ctx.saving ? "Sauvegarde..." : "Sauvegarder"), 1)
      ], 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, "Ajouter un congé", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(BaseInput), {
              modelValue: newLeave.startDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newLeave.startDate) = $event)),
              label: "Début de congé",
              type: "date",
              min: minStartDate.value
            }, null, 8, ["modelValue", "min"]),
            _createVNode(_unref(BaseInput), {
              modelValue: newLeave.endDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newLeave.endDate) = $event)),
              label: "Fin de congé",
              type: "date",
              min: minEndDate.value
            }, null, 8, ["modelValue", "min"]),
            _createElementVNode("div", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-1" }, " ", -1)),
              _createVNode(_unref(ActionButton), {
                label: _ctx.saving ? 'Ajout...' : 'Ajouter',
                icon: _ctx.saving ? 'fas fa-spinner fa-spin' : 'fas fa-plus',
                variant: "primary",
                onClick: addLeave,
                disabled: !newLeave.startDate || !newLeave.endDate || _ctx.saving
              }, null, 8, ["label", "icon", "disabled"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("nav", _hoisted_10, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (activeTab.value = 'active')),
                class: _normalizeClass([
                'py-2 px-1 border-b-2 font-medium text-sm',
                activeTab.value === 'active'
                  ? 'border-purple-500 text-purple-600'
                  : 'border-transparent text-black hover:text-black hover:border-gray-300'
              ])
              }, [
                _cache[7] || (_cache[7] = _createTextVNode(" Congés actifs ")),
                _createElementVNode("span", _hoisted_11, _toDisplayString(activeLeaves.value.length), 1)
              ], 2),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (activeTab.value = 'deleted')),
                class: _normalizeClass([
                'py-2 px-1 border-b-2 font-medium text-sm',
                activeTab.value === 'deleted'
                  ? 'border-red-500 text-red-600'
                  : 'border-transparent text-black hover:text-black hover:border-gray-300'
              ])
              }, [
                _cache[8] || (_cache[8] = _createTextVNode(" Anciens congés supprimés ")),
                _createElementVNode("span", _hoisted_12, _toDisplayString(deletedLeaves.value.length), 1)
              ], 2)
            ])
          ]),
          (activeTab.value === 'active')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("table", _hoisted_15, [
                    _cache[10] || (_cache[10] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "N°"),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "Début de congé"),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "Fin de congé"),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "Action")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", _hoisted_16, [
                      (activeLeaves.value.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _cache[9] || (_cache[9] = [
                            _createElementVNode("td", {
                              colspan: "4",
                              class: "px-4 py-8 text-center text-black"
                            }, [
                              _createElementVNode("i", { class: "fas fa-calendar-times text-4xl text-black mb-2 block" }),
                              _createTextVNode(" Aucun congé enregistré ")
                            ], -1)
                          ])))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeLeaves.value, (leave, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_18, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(formatDate(leave.startDate)), 1),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(formatDate(leave.endDate)), 1),
                          _createElementVNode("td", _hoisted_21, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (deleteLeave(_ctx.formData.leaves.indexOf(leave))),
                              class: "text-red-600 hover:text-red-900"
                            }, " Supprimer ", 8, _hoisted_22)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (activeTab.value === 'deleted')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("table", _hoisted_25, [
                    _cache[13] || (_cache[13] = _createElementVNode("thead", { class: "bg-red-50" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "N°"),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "Début de congé"),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "Fin de congé"),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, "Statut")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", _hoisted_26, [
                      (deletedLeaves.value.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_27, _cache[11] || (_cache[11] = [
                            _createElementVNode("td", {
                              colspan: "4",
                              class: "px-4 py-8 text-center text-black"
                            }, [
                              _createElementVNode("i", { class: "fas fa-trash text-4xl text-black mb-2 block" }),
                              _createTextVNode(" Aucun ancien congé supprimé ")
                            ], -1)
                          ])))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deletedLeaves.value, (leave, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: "bg-red-50"
                        }, [
                          _createElementVNode("td", _hoisted_28, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", _hoisted_29, _toDisplayString(formatDate(leave.startDate)), 1),
                          _createElementVNode("td", _hoisted_30, _toDisplayString(formatDate(leave.endDate)), 1),
                          _cache[12] || (_cache[12] = _createElementVNode("td", { class: "px-4 py-3 whitespace-nowrap text-sm text-red-600" }, [
                            _createElementVNode("span", { class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" }, [
                              _createElementVNode("i", { class: "fas fa-trash mr-1" }),
                              _createTextVNode(" Supprimé ")
                            ])
                          ], -1))
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})